import { modalController } from '@ionic/core';
import { Component, Element, Event, EventEmitter, forceUpdate, Fragment, h, Prop } from '@stencil/core';
import { DateUtils, FileDoc } from 'common';
import { DrawingDoc } from 'common';
import { User } from 'src/global/models';
import { DateSelector } from 'src/global/ui/date-selector';
import { DrawingAnalysisModal } from './drawing-analysis-modal';

@Component({
  tag: 'drawing-settings-modal',
  //styleUrl: 'drawing-upload-modal.css',
  //shadow: true,
})
export class DrawingSettingsModal {
  static async present(projectId: string, drawing: DrawingDoc, callback: (file: FileDoc) => void): Promise<void> {
    const modal = await modalController.create({
      component: 'drawing-settings-modal',
      componentProps: { projectId, drawing },
      cssClass: 'concourse-modal modal-height-auto',
      showBackdrop: true,
      backdropDismiss: false,
    });

    modal.addEventListener('save', (e: CustomEvent) => {
      callback(e.detail as FileDoc);
      modal.dismiss();
    });

    modal.addEventListener('dismiss', () => {
      modal.dismiss();
    });

    modal.present();
  }

  @Element() hostElement: HTMLElement;

  @Prop() projectId: string;
  @Prop() drawing: DrawingDoc;

  @Event() save: EventEmitter<DrawingDoc>;
  @Event() dismiss: EventEmitter;

  get user(): User {
    return globalThis.user;
  }

  componentDidLoad() {}

  async showDateSelector() {
    DateSelector.presentModal(this.drawing.version_date, (date: string) => {
      this.drawing.version_date = date;
      forceUpdate(this);
    });
  }

  analyseFile() {
    DrawingAnalysisModal.present(this.projectId, this.drawing._id, null, () => {
      console.log('analysis complete');
    });
    this.dismiss.emit();
  }

  render() {
    return (
      <Fragment>
        <modal-header modalTitle={(this.drawing.title || this.drawing.name) + ' Settings'} onDismiss={() => this.dismiss.emit()}></modal-header>
        <ion-page class="ion-padding">
          <ion-input
            label="Title (optional)"
            label-placement="stacked"
            class="cc-margin-bottom"
            value={this.drawing.title}
            onIonChange={e => (this.drawing.title = e.detail.value)}
          ></ion-input>
          <div class="small-super-script">Version Date</div>
          <ion-button class="pseudo-input" fill="clear" expand="block" color="light" onClick={() => this.showDateSelector()}>
            <ion-label slot="start">{DateUtils.formatIso(this.drawing.version_date)}</ion-label>
            <ion-icon slot="end" class="spaced-icon" name="calendar-number-outline" />
          </ion-button>
        </ion-page>
        <ion-footer>
          <ion-toolbar>
            <ion-button slot="start" shape="round" fill="outline" onClick={e => this.analyseFile()}>
              <ion-label>Analyse with AI</ion-label>
            </ion-button>
            <ion-button slot="end" shape="round" onClick={e => this.save.emit(this.drawing)}>
              <ion-label>Save</ion-label>
            </ion-button>
          </ion-toolbar>
        </ion-footer>
      </Fragment>
    );
  }
}
